// extracted by mini-css-extract-plugin
module.exports = {"icon-spin":"icon_icon-spin__2QArW","loadingCircle":"icon_loadingCircle__2bbUO","tip-icon":"icon_tip-icon__NcUlO"};